import * as React from 'react';
import './image-page-title.scss';
export const ImagePageTitle = (props) => {
  const { image, title } = props;
  return (
    <div className="image-page-title-wrapper">
      <img className="image-1" src={image} alt={title} />
      <img className="image-2" src={image} alt={title} />
      <div className="image-title">{title}</div>
    </div>
  );
};

export default ImagePageTitle;
